<template>
	<v-dialog v-model="dialog" fullscreen>
		<v-card>
			<!-- HEADER -->
			<v-toolbar dark color="grey darken-3" class="elevation-0">
				<v-toolbar-title class="text-h6 font-weight-bold">
					<span class="text-h6">Adicionar um novo vade-mécum</span>
				</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon @click="closeDialog">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-divider></v-divider>

			<v-card-actions class="" style="width: 100%;">
				<v-row style="background-color: #f8f9fa;">
					<v-col cols="12" md="12" class="d-flex justify-end align-center">
						<v-btn color="#F15A24" dark large :loading="loadingNewVade" @click="postVadeMecum">
							Salvar e finalizar
						</v-btn>
					</v-col>
				</v-row>
			</v-card-actions>

			<!-- MAIN CONTENT -->
			<v-card-text>
				<v-container fluid>
					<v-row>
						<!-- COLUNA ESQUERDA: FORM -->
						<v-col cols="12" md="6">
							<h3 class="mb-2">Título</h3>
							<v-text-field 
								color="#F15A24" 
								v-model="newVadeMecum" 
								label="Seu título aqui"
								counter="30" 
								outlined 
							/>
							
							<h3 class="mt-4 mb-2">Cor</h3>
							<v-color-picker 
								class="mx-auto" 
								:swatches="swatches" 
								v-model="newVadeMecumColor"
								hide-inputs 
								show-swatches 
								flat 
							/>
						</v-col>
						
						<!-- COLUNA DIREITA: LISTA DE LEGISLAÇÕES -->
						<v-col cols="12" md="6" class="pl-md-6">
							<div class="mt-8">
								<v-text-field 
									v-on:keyup.enter="searchLeisInVadeMecum"
									:disabled="loadingInternalSearch" 
									clearable 
									v-model="searchAddLeis"
									@click:clear="clearInternalSearch" 
									@click:append="searchLeisInVadeMecum"
									:append-icon="loadingSearch ? `mdi-loading` : `mdi-magnify`" 
									color="#F15A24"
									hide-details 
									outlined
									placeholder="Pesquise pelo número (10.406) ou palavra da ementa (Código Civil)"
									label="Pesquise pelo número (10.406) ou palavra da ementa (Código Civil)" 
								/>
							</div>
							<div style="overflow: scroll; max-height: 400px;">
								<v-list class="mt-3">
									<v-list-item-title>
										Legislações sugeridas:
									</v-list-item-title>
									<v-list-item class="px-0 text-center d-flex justify-center"
										v-if="loadingInternalSearch">
										<v-progress-circular indeterminate></v-progress-circular>
									</v-list-item>
									<v-list-item class="px-0 text-center d-flex justify-center"
										v-if="internalLeisSearch.length === 0 && !loadingInternalSearch">
										<p>Nenhuma legislação encontrada, confira os filtros acima.</p>
									</v-list-item>
									<v-hover v-slot="{ hover }" v-for="item in internalLeisSearch"
										:key="item.id_lei">
										<v-list-item :class="hover ? `bkgHover` : ``"
											style="border-top: 1px solid #F15A24; border-radius: 10px"
											class="mb-5">
											<v-list-item-content>
												<v-row align="center" class="mb-2" no-gutters>
													<v-col class="pa-0">
														<v-list-item-title>
															<span v-html="highlight(item.numero_lei, searchAddLeis)"></span>
														</v-list-item-title>
													</v-col>
													<v-col class="pa-0 mt-1">
														<v-chip class="mr-2" color="#F15A24" outlined
															text-color="#F15A24" style="height: 1.5rem">
															{{ item.esfera_lei }}
														</v-chip>
														<v-chip color="#F15A24" outlined text-color="#F15A24"
															v-if="item.esfera_lei === `Estadual`"
															style="height: 1.5rem">
															{{ item.estado_lei }}
														</v-chip>
														<v-chip class="ml-2" color="#F15A24" outlined
															text-color="#F15A24"
															v-if="item.esfera_lei === `Municipal`"
															style="height: 1.5rem">
															{{ item.municipio_lei }}
														</v-chip>
													</v-col>
												</v-row>
												<div>
													<small v-html="highlight(item.nome_lei, searchAddLeis)"></small>
												</div>
											</v-list-item-content>

											<v-list-item-action class="text-center">
												<span class="text-subtitle"
													style="min-width: 90px; text-transform: uppercase" 
													v-if="idleis.includes(item.id_lei)">
													Adicionado
												</span>
												<v-btn 
													v-else 
													small 
													text 
													color="#F15A24" 
													:loading="item.loading"
													@click="adicionarLeiNaCriacao(item)" 
													:disabled="idleis.includes(item.id_lei)">
													Adicionar
												</v-btn>
											</v-list-item-action>
										</v-list-item>
									</v-hover>
								</v-list>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'DialogAddVademecum',
	props: {
		value: {
			type: Boolean,
			default: false,
		},
		grupoId: {
			type: String,
			default: null,
		},
		limiteVadeMecuns: {
			type: Number,
			default: null,
		},
		quantidadeVadeMecuns: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			dialog: this.value,
			newVadeMecum: '',
			newVadeMecumColor: '#F15A24',
			searchAddLeis: '',
			internalLeisSearch: [],
			idleis: [],
			loadingInternalSearch: false,
			loadingSearch: false,
			loadingNewVade: false,
			currentPage: 1,
			itemsPerPage: 10,
			totalItems: 0,
			filterEsfera: 0,
			selectEstadualSelected: '*',
			selectMunicipalSelected: '*',
			filterOptions: [
				{ text: 'Todas', value: 'Todos', disabled: false },
				{ text: 'Federal', value: 'Federal', disabled: false },
				{ text: 'Estadual', value: 'Estadual', disabled: false },
				{ text: 'Municipal', value: 'Municipal', disabled: false },
			],
			selectEstadualOptions: [
				{ text: 'Todos', value: '*', disabled: false },
				{ text: 'Rio de Janeiro', value: 'RJ', disabled: false },
				{ text: 'São Paulo', value: 'SP', disabled: false },
				{ text: 'Belo Horizonte', value: 'MG', disabled: false },
			],
			selectMunicipalOptions: [
				{ text: 'Todos', value: '*', disabled: false },
				{ text: 'Rio de Janeiro', value: 'RJ', disabled: false },
				{ text: 'São Paulo', value: 'SP', disabled: false },
			],
			swatches: [
				['#FF0000', '#AA0000', '#550000'],
				['#FFFF00', '#AAAA00', '#555500'],
				['#00FF00', '#00AA00', '#005500'],
				['#00FFFF', '#00AAAA', '#005555'],
				['#0000FF', '#0000AA', '#000055'],
			],
		};
	},
	watch: {
		value(newVal) {
			this.dialog = newVal;
			if (newVal) {
				// Quando abrir, buscar leis iniciais
				this.searchLeisInVadeMecum();
			} else {
				// Quando fechar, limpar estado
				this.clearState();
			}
		},
		dialog(newVal) {
			this.$emit('input', newVal);
		},
	},
	methods: {
		closeDialog() {
			this.dialog = false;
		},
		clearState() {
			this.newVadeMecum = '';
			this.newVadeMecumColor = '#F15A24';
			this.searchAddLeis = '';
			this.internalLeisSearch = [];
			this.idleis = [];
			this.currentPage = 1;
			this.totalItems = 0;
		},
		highlight(content, query) {
			if (!query) {
				return content;
			}
			return content.replace(new RegExp(query, 'gi'), (match) => {
				return '<span class="my-orange">' + match + '</span>';
			});
		},
		adicionarLeiNaCriacao(item) {
			// Verificar se já está adicionada
			if (this.idleis.includes(item.id_lei)) {
				return;
			}

			// Ativar loading
			this.$set(item, 'loading', true);

			// Simular um pequeno delay para feedback visual melhor
			setTimeout(() => {
				// Adicionar à lista
				this.idleis.push(item.id_lei);
				
				// Desativar loading
				this.$set(item, 'loading', false);

				// Forçar atualização da view
				this.$forceUpdate();
			}, 300);
		},
		clearInternalSearch() {
			this.searchAddLeis = '';
			this.totalItems = 0;
			this.internalLeisSearch = [];
			this.currentPage = 1;
			this.searchLeisInVadeMecum();
		},
		async searchLeisInVadeMecum() {
			if (this.searchAddLeis == null) this.searchAddLeis = "";
			if (!isNaN(this.searchAddLeis) &&
				this.searchAddLeis.indexOf('.') == -1) {
				this.searchAddLeis = this.searchAddLeis.replace(
					/(\d)(?=(\d{3})+$)/g,
					'$1.'
				);
			}

			const searchQuery = this.searchAddLeis
				? `search:"${this.searchAddLeis}", `
				: '';

			const offset = (this.currentPage - 1) * this.itemsPerPage;

			let filter = 'filter: { esfera_lei: { _nnull: true}}'
			if (this.filterEsfera == 1) {
				filter = `filter: { esfera_lei: {_eq: "${this.filterOptions[this.filterEsfera].value}"} }, `
			}

			if (this.filterEsfera == 2) {
				filter = `filter: {  esfera_lei: {_eq: "${this.filterOptions[this.filterEsfera].value}"}
					 ${this.selectEstadualSelected !== "*" ? `, estado_lei: { _eq: "${this.selectEstadualSelected}"}` : ``}
					},`
			}
			if (this.filterEsfera == 3) {
				filter = `filter: { esfera_lei: {_eq: "${this.filterOptions[this.filterEsfera].value}"}
					 ${this.selectMunicipalSelected !== "*" ? `, municipio_lei: { _eq: "${this.selectMunicipalSelected}"}` : ``}
					},`
			}

			const query = `
				query FilterByApelidosLeis {
					leis(${filter}${searchQuery}sort: ["-ranking_lei", "-data_lei"], limit: ${this.itemsPerPage}, offset: ${offset}) {
					id_lei
					numero_lei
					data_lei
					nome_lei
					estado_lei
					municipio_lei
					esfera_lei
					ranking_lei
					}
					leis_aggregated(${filter}${searchQuery}) {
					count { id_lei }
					}
				}
				`;

			this.loadingInternalSearch = true;
			this.internalLeisSearch = [];
			this.totalItems = 0;

			try {
				const response = await this.$http.post(
					'https://api.mylegis.com.br/graphql',
					{ query }
				);
				const { leis, leis_aggregated } = response.data.data;
				this.internalLeisSearch = leis.map(v => ({ ...v, loading: false }));
				this.totalItems = leis_aggregated[0].count.id_lei;
				this.loadingInternalSearch = false;
			} catch (error) {
				this.loadingInternalSearch = false;
				window.console.error('Erro ao buscar as leis:', error.response);
			}
		},
		async postVadeMecum() {
			// Validar limite se fornecido
			if (this.limiteVadeMecuns !== null && this.quantidadeVadeMecuns >= this.limiteVadeMecuns) {
				alert(`Você atingiu o limite de ${this.limiteVadeMecuns} vade-mécuns. Para criar mais vade-mécuns, faça upgrade do seu plano.`);
				return;
			}

			this.loadingNewVade = true;
			
			try {
				// Preparar dados do vademecum
				const vademecumData = {
					titulo: this.newVadeMecum,
					cor: this.newVadeMecumColor,
					status: 'published',
				};

				// Se for para grupo, adicionar id_grupo
				if (this.grupoId) {
					vademecumData.id_grupo = this.grupoId;
				}

				const { data } = await this.$http.post('/items/vademecums', vademecumData);
				
				// Adicionar leis selecionadas
				if (this.idleis.length > 0) {
					for (const id of this.idleis) {
						await this.$http.patch('/items/vademecums/' + data.data.id, {
							leis: {
								create: [
									{
										leis_id_lei: { id_lei: id },
										vademecums_id: data.data.id,
									},
								],
							},
						});
					}
				}

				this.loadingNewVade = false;
				this.closeDialog();
				
				// Emitir evento de sucesso
				this.$emit('saved', data.data);
			} catch (error) {
				this.loadingNewVade = false;
				window.console.error('Erro ao criar vade-mécum:', error);
				alert('Erro ao criar vade-mécum. Tente novamente.');
			}
		},
	},
};
</script>

<style scoped>
.bkgHover {
	background-color: #fff5f2;
}
</style>

